export default __webpack_public_path__ + "static/media/kcard_logo.2a97667b.png";